import axios from 'axios'

import demo from './modules/demo'
import common from './modules/common'
import ems from './modules/ems'
import user from './modules/user'
import partyA from './modules/partyA'

export default {
    axios: axios,
    demo,
    common,
    user,
    ems,
    partyA
}



// WEBPACK FOOTER //
// ./src/api/index.js